import { RoadmapListParams } from '../../api/types';

export type ApiRoadmapFilterCfg = {
  platform: string;
  roadmap: 'all' | 'yes' | 'no';
  minOrigin: string;
  dateFrom: string;
  dateTo: string;
  staleOnly: boolean;
  playerId: string;
  userType: string;
};

export const STALE_INACTIVE_DAYS = 10;
export const ROADMAP_LIST_PAGE_SIZE = 10;

export const USER_TYPE_FILTER_OPTIONS = [
  { value: '', label: 'Tüm kullanıcı tipleri' },
  { value: 'REGULAR', label: 'REGULAR' },
  { value: 'PREMIUM', label: 'PREMIUM' },
  { value: 'TESTER', label: 'TESTER' },
  { value: 'DEPRECATED', label: 'DEPRECATED' },
] as const;

export function apiRoadmapFiltersActive(f: ApiRoadmapFilterCfg): boolean {
  return (
    !!f.platform.trim() ||
    f.roadmap !== 'all' ||
    !!f.minOrigin.trim() ||
    !!f.dateFrom.trim() ||
    !!f.dateTo.trim() ||
    f.staleOnly ||
    !!f.playerId.trim() ||
    !!f.userType.trim()
  );
}

export function buildRoadmapListParams(page: number, f: ApiRoadmapFilterCfg): RoadmapListParams {
  const params: RoadmapListParams = { page };
  const platform = f.platform.trim();
  if (platform) params.platform = platform;
  if (f.roadmap === 'yes') params.completed_from_roadmap = true;
  else if (f.roadmap === 'no') params.completed_from_roadmap = false;
  const minStr = f.minOrigin.trim();
  if (minStr !== '') {
    const minO = parseInt(minStr, 10);
    if (!Number.isNaN(minO)) params.min_origin = minO;
  }
  if (f.dateFrom.trim()) params.from_date = `${f.dateFrom.trim()}T00:00:00`;
  if (f.dateTo.trim()) params.upto_date = `${f.dateTo.trim()}T23:59:59.999`;
  if (f.staleOnly) params.last_activity_n_days_ago = STALE_INACTIVE_DAYS;
  const pid = f.playerId.trim();
  if (pid) params.player_id = pid;
  const ut = f.userType.trim();
  if (ut) params.user_type = ut;
  return params;
}
